module.exports = __webpack_public_path__ + "img/photo-27.759a3af5.jpg";